<!-- Approve Booking Dates Modal Starts -->
<div class="modal add-appointment fade" id="approve-booking-dates" data-keyboard="false" tabindex="-1"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content w-100">
            <div class="modal-body">
                <form [formGroup]="bookingForm">
                    <div class="d-flex flex-column px-3">
                        <div class="d-flex flex-row justify-content-between mt-3 mb-1">
                            <span class="modal-title">Approve booking request</span>
                            <i class="fas fa-times modal-close" data-dismiss="modal"></i>
                        </div>
                        <span class="mt-2 mb-2 modal-text" *ngIf="bookingReq!=undefined">Due on:
                            {{bookingReq.mumRequested[0].dueDate | date:'EEE dd
                            MMM yyyy'}}</span>
                        <span class="mt-2 mb-4 modal-text">{{bookingReq?.message}}</span>
                        <span class="title mb-2">From</span>
                        <div class="d-flex flex-row justify-content-between">
                            <select name="from day" id="from-day" class="form-control form-control-sm"
                                (change)="validateDate()" formControlName="fromDay">
                                <option [value]="day" *ngFor="let day of fromDaysDrop">{{day}}</option>
                            </select>
                            <select name="from month" id="from-month" class="form-control form-control-sm mx-2"
                                (change)="validateDate()" formControlName="fromMonth">
                                <option [value]="month.no" *ngFor="let month of months">{{month.text}}</option>
                            </select>
                            <select name="from year" id="from-year" class="form-control form-control-sm"
                                (change)="validateDate()" formControlName="fromYear">
                                <option [value]="year" *ngFor="let year of years">{{year}}</option>
                            </select>
                        </div>
                        <span *ngIf="fromDateError" class="error">Invalid Date</span>
                        <span class="title mt-3 mb-2">To</span>
                        <div class="d-flex flex-row justify-content-between">
                            <select name="to day" id="to-day" class="form-control form-control-sm"
                                formControlName="toDay" (change)="validateDate()">
                                <option [value]="day" *ngFor="let day of toDaysDrop">{{day}}</option>
                            </select>
                            <select name="to month" id="to-month" class="form-control form-control-sm mx-2"
                                (change)="validateDate()" formControlName="toMonth">
                                <option [value]="month.no" *ngFor="let month of months">{{month.text}}</option>
                            </select>
                            <select name="to year" id="to-year" class="form-control form-control-sm"
                                (change)="validateDate()" formControlName="toYear">
                                <option [value]="year" *ngFor="let year of years">{{year}}</option>
                            </select>
                        </div>
                        <span *ngIf="toDateError" class="error">Invalid Date</span>
                        <div class="d-flex flex-row justify-content-end mt-5 mb-3">
                            <button class="btn btn-cancel mr-2" data-dismiss="modal">Cancel</button>
                            <button
                                class="btn btn-theme" [disabled]="!bookingForm.valid || fromDateError || toDateError"
                                (click)="approveBooking()">
                                <div class="d-flex flex-row justify-content-center">
                                    <div class="spinner-border loader" role="status" *ngIf="loading">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span class="align-self-center" *ngIf="!loading">Confirm</span>
                                </div>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
<!-- Approve Booking Dates Modal Ends -->

<!-- Booking Request Approved Modal Starts -->
<div class="modal approved fade" id="request-approved-modal" data-keyboard="false" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content w-100">
            <div class="modal-body">
                <div class="container-fluid">
                    <div class="d-flex flex-column py-2">
                        <div class="correct-icon-section text-center mt-3">
                            <i class="fas fa-check correct-icon"></i>
                        </div>
                        <span class="header mt-3 text-center">Booking request approved</span>
                        <div class="sub-section py-2 px-2 my-3" *ngIf="bookingReq!=undefined">
                            <div class="d-flex flex-row">
                                <img class="profile-img" *ngIf="!bookingReq.mumRequested[0].profileImage" 
                                src="../../../../../../assets/Images/pro-pic.png">
                                <img class="profile-img" *ngIf="bookingReq.mumRequested[0].profileImage"
                                 [src]="bookingReq.mumRequested[0].profileImage">
                                <div class="d-flex flex-column flex-grow ml-3">
                                    <span class="title">{{bookingReq.mumRequested[0].name}}</span>
                                    <div class="d-flex flex-row mt-2 mb-2">
                                        <i class="far fa-clock icon"></i>
                                        <span class="section-text ml-3">{{fromDate | date:'EEE dd MMM'}} - {{toDate | date:'EEE dd MMM'}}</span>
                                    </div>
                                    <div class="d-flex flex-row mb-2">
                                        <i class="fas fa-phone icon phone"></i>
                                        <span class="section-text ml-3">{{bookingReq.mumRequested[0].user[0].userPhonenumber}}</span>
                                    </div>
                                    <div class="d-flex flex-row my-2">
                                        <i class="fas fa-envelope icon"></i>
                                        <span class="section-text ml-3">{{bookingReq.mumRequested[0].user[0].userEmail}}</span>
                                    </div>
                                    <div class="d-flex flex-row my-2">
                                        <i class="fas fa-map-marker-alt icon pl-1"></i>
                                        <span class="section-text ml-3">{{bookingReq.mumRequested[0].address}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button class="btn btn-theme w-100 my-2" data-dismiss="modal">Ok</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Booking Request Approved Modal Ends -->